import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Input } from "reactstrap";
import { connect } from 'react-redux';
import ReactTable from "react-table";
import fetchCatlogDetailsForProductListingService from "../../../../../Service/OPSServices/AmazonProductListing/fetchCatlogDetailsForProductListingService";

function ProductListingStore(props) {

  const [selectedStore, setSelectedStore] = useState("");
  const [selectedStoreDetails, setSelectedStoreDetails] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [selectedAsin, setSelectedAsin] = useState(
    props.listingData && props.listingData.asin || ""
  );
  //  Restore store + asin on back
  useEffect(() => {
    if (props.listingData && props.listingData.storeId && props.storeList) {

      const storeId = Number(props.listingData.storeId);

      setSelectedStore(storeId);

      const store = props.storeList.find(s => s.id === storeId);
      setSelectedStoreDetails(store || null);

      setSelectedAsin(props.listingData.asin || "");
    }
  }, [props.listingData, props.storeList]);

  // Handle store change
  const handleStoreChange = (e) => {
    const storeId = Number(e.target.value); 

    setSelectedStore(storeId);

    const store = props.storeList && props.storeList.find(s => s.id === storeId);
    setSelectedStoreDetails(store || null);
  };

  // Filter product list
  const filterProductData = selectedStoreDetails
    ? (selectedStoreDetails.products || []).filter((row) => {
        const text = searchText.toLowerCase();

        return (
          (row.parentProduct || '').toLowerCase().includes(text) ||
          (row.asin || '').toLowerCase().includes(text) ||
          (row.productTitle || '').toLowerCase().includes(text)
        );
      })
    : [];

  // ASIN click
  const handleAsinClick = async (product) => {

    if (!selectedStoreDetails) return; 

    setSelectedAsin(product.asin); 

    const res = await fetchCatlogDetailsForProductListingService(
      props.token,
      { asin: product.asin }
    );
    console.log(res);

    props.setListingData(prev => ({
      ...prev,
      storeId: selectedStoreDetails.id,
      sellerId: selectedStoreDetails.stringID,
      marketplaceId: selectedStoreDetails.marketplaceStringId,
      asin: product.asin,

      // raw API
      catalogData: res,

      //editable form data
      formData: {
        productTitle: res.productTitle || "",
        brand: res.brand || "",
        sku: res.sku || "",
        category: res.category || "",
        color: res.color || "",
        size: res.size || "",
        material: res.material || "",
        bullets: res.bullets || [],
        description: res.description || "",
        mainImage: res.main_image || "",
        galleryImages: res.gallery_images || [],
        price: res.price || "",
        quantity: res.quantity || "",
        currency: res.currency || selectedStoreDetails.currencyCode
      }
    }));

    props.nextStep();
  };

  const columns = [
    {
      Header: "Parent Asin",
      accessor: "parentProduct",
      width: 110,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className='mb-0'>{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: "Asin",
      accessor: "asin",
      width: 110,
      Cell: (cellInfo) => {
        const isSelected = selectedAsin === cellInfo.value;

        return (
          <div className="d-flex justify-content-center w-100">
            <p
              className='mb-0'
              style={{
                cursor: "pointer",
                textDecoration: "underline",
                color: "blue",
                fontWeight: isSelected ? "bold" : "normal"
              }}
              onClick={() => handleAsinClick(cellInfo.row._original)}
            >
              {cellInfo.value}
            </p>
          </div>
        );
      }
    },
    {
      Header: "Product Title",
      accessor: "productTitle",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-start w-100">
          <p title={cellInfo.value} className='mb-0'>{cellInfo.value}</p>
        </div>
      ),
    },
  ];

  return (
    <>
      <Container>
        <Row>

          {/* Page Title */}
          <Col md={12} className="mt-2 mb-2">
            <h4>Step 1 : Store Selection</h4>
          </Col>

          {/* Store Selection Card */}
          <Col md={12} className="ml-1 mr-4">
            <Card className="p-4">

              <Row className="mb-3">
                <Col md={4} className="amazon-listing-labels">Store : </Col>
                <Col md={8}>
                  <Input
                    type="select"
                    value={selectedStore}
                    onChange={handleStoreChange}
                  >
                    <option value="">-- Select Store --</option>
                    {props.storeList && props.storeList.map((store) => (
                      <option key={store.id} value={store.id}>
                        {store.name}
                      </option>
                    ))}
                  </Input>
                </Col>
              </Row>

              {/* Store Details */}
              {selectedStoreDetails && (
                <>
                  <Row className="mt-4 mb-2">

                    <Col md={4}>
                      <p className="mb-0"><b>Seller ID</b></p>
                      <p>{selectedStoreDetails.stringID}</p>
                    </Col>

                    <Col md={4}>
                      <p className="mb-0"><b>Marketplace ID</b></p>
                      <p>{selectedStoreDetails.marketplaceStringId}</p>
                    </Col>

                    <Col md={4}>
                      <p className="mb-0"><b>Currency</b></p>
                      <p>{selectedStoreDetails.currencyCode}</p>
                    </Col>

                  </Row>

                  <Row>
                    <Col md={12} className="d-flex justify-content-end">
                      <Input
                        className="mb-2 w-50"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        placeholder="Search product by Title and ASIN "
                      />
                    </Col>

                    <Col md={12}>
                      <ReactTable
                        data={filterProductData}
                        columns={columns}
                        className="-fixed -highlight -striped mt-2"
                        getTheadProps={() => ({
                          style: {
                            overflowY: "hidden",
                            background: "#B1FA63",
                            color: "#243837",
                          },
                        })}
                        getTrProps={(state, rowInfo) => {
                          if (rowInfo && rowInfo.original && rowInfo.original.isParentProduct) {
                            return {
                              style: {
                                backgroundColor: '#dfd7ff',
                              },
                            };
                          }
                          return {};
                        }}
                        defaultPageSize={5}
                        noDataText={"No Data Found."}
                      />
                    </Col>
                  </Row>
                </>
              )}

            </Card>
          </Col>

        </Row>
      </Container>
    </>
  );
}

const mapStateToProps = state => ({
  token: state.loggedUser.token,
  accessLevel: state.loggedUser.accessLevel,
  status: state.loggedUser.status,
});

export default connect(mapStateToProps)(ProductListingStore);